import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { OrdenItem } from '../../domain/orden.domain';

@Injectable({
  providedIn: 'root'
})
export class OrdenItemService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.URL_API}/orden-items`;

  private normalizePayload(payload: Partial<OrdenItem>): Partial<OrdenItem> {
    const normalized: Partial<OrdenItem> = { ...payload };

    if ('subtotalManual' in normalized) {
      const raw = normalized.subtotalManual as unknown;
      if (raw === null || raw === undefined) {
        normalized.subtotalManual = null;
      } else if (typeof raw === 'number') {
        normalized.subtotalManual = String(raw);
      } else if (typeof raw === 'string') {
        const value = raw.trim().replace(',', '.');
        normalized.subtotalManual = value === '' ? null : value;
      }
    }

    return normalized;
  }

  create(payload: Partial<OrdenItem> & { orden: string }): Observable<OrdenItem> {
    return this.http.post<OrdenItem>(this.apiUrl, this.normalizePayload(payload));
  }

  update(id: number, payload: Partial<OrdenItem>): Observable<OrdenItem> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json'
    });
    return this.http.patch<OrdenItem>(`${this.apiUrl}/${id}`, this.normalizePayload(payload), { headers });
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
